import EditProfileForm from "../EditProfileForm/EditProfileForm";
import { TrashCan } from "@carbon/icons-react";
import { logout, removeUserInfo } from "@/services/users";
import { useAuth } from "@/context/AuthContext";
import { useToastContext } from "@/context/ToastContext";
import styles from "./UserProfile.module.scss";
import Button from "@/components/buttons/Button/Button";

export const UserProfile = () => {
  const { user } = useAuth();
  const { showSuccessAlert, showWarningAlert, showErrorAlert } =
    useToastContext();

  const confirmRemove = () => {
    showWarningAlert(
      "Are you sure you want to delete your account?",
      "Confirm",
      handleRemove
    );
  };

  const handleRemove = () => {
    removeUserInfo(user.email)
      .then((response: any) => {
        if (response) {
          showSuccessAlert("User removed");
          logout();
        }
      })
      .catch((error: any) => {
        showErrorAlert(error.message || "Error removing user");
      });
  };

  const DeleteAccount = (
    <Button
      variant="danger"
      size="lg"
      className="w-full mt-2"
      onClick={confirmRemove}
    >
      <TrashCan size={24} />
      <p>Delete account</p>
    </Button>
  );

  return (
    <div className={styles.userProfileContainer}>
      <EditProfileForm />
      {DeleteAccount}
    </div>
  );
};

export default UserProfile;
